import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase.js';
import { useToast } from '../context/ToastContext';
import { useNavigate } from 'react-router-dom';
import { FiChevronLeft } from 'react-icons/fi';

import { Button } from '../components/ui/atoms/Button/Button';
import { Input } from '../components/ui/atoms/input/Input';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);
  const { showToast } = useToast() as any;
  const navigate = useNavigate();
  const [validEmail, setValidEmail] = useState(true);

  const handleReset = async () => {
    if (!email) {
      showToast({ message: 'Please enter your email.', type: 'error' });
      return;
    }
    setSending(true);
    try {
      await sendPasswordResetEmail(auth, email);
      showToast({
        message: 'Check your inbox for a reset link.',
        type: 'success',
      });
      navigate('/auth');
    } catch (err) {
      console.error('Reset email error:', err);
      showToast({
        message: "Couldn't send reset email. Check the address.",
        type: 'error',
      });
    } finally {
      setSending(false);
    }
  };

  const checkEmailFormat = (email: string) => {
    setValidEmail(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email));
  };

  const onEmailChange = (e) => {
    setEmail(e);
    setValidEmail(true);
  };

  return (
    <div className="background-light-primary min-h-screen flex items-center justify-center px-4">
      <div className="bg-white shadow-xl rounded-2xl w-full max-w-sm px-6 py-6 space-y-4 text-center">
        <div className="relative flex items-center justify-center mb-4 h-10">
          <button
            onClick={() => navigate(-1)}
            className="absolute left-0 pl-1 text-primary"
            aria-label="Go back"
          >
            <FiChevronLeft className="w-6 h-6" />
          </button>
          <h4 className="text-xl font-semibold text-primary">
            Forgot Password
          </h4>
        </div>

        <Input
          onBlur={() => checkEmailFormat(email)}
          placeholder="Enter your email"
          type="email"
          value={email}
          setValue={onEmailChange}
        />

        {!validEmail && (
          <div className="text-sm text-red-500">Please use valid email</div>
        )}

        <Button
          disabled={!validEmail || sending}
          variant="black"
          className="bg-brandPurpleDark disabled:bg-brandPurpleLight disabled:text-brandPurpleDark"
          onClick={handleReset}
        >
          {sending ? 'Sending...' : 'Send Reset Link'}
        </Button>
      </div>
    </div>
  );
};

export default ForgotPassword;
